export const REGISTER_USER_REQUEST = `[auth] Register user request` as const;
export const REGISTER_USER_SUCCESS = `[auth] Register user success` as const;
export const REGISTER_USER_FAILED = `[auth] Register user failed` as const;

export const LOGIN_REQUEST = `[auth] Login request` as const;
export const LOGIN_SUCCESS = `[auth] Login success` as const;
export const LOGIN_FAILED = `[auth] Login failed` as const;

export const AUTO_LOGIN_REQUEST = `[auth] Auto Login request` as const;

export const LOGIN_BY_VERIFICATION_CODE_REQUEST = `[auth] Login by VC request` as const;
export const LOGIN_BY_VERIFICATION_CODE_SUCCESS = `[auth] Login by VC success` as const;
export const LOGIN_BY_VERIFICATION_CODE_FAILED = `[auth] Login by VC failed` as const;

export const LOGOUT_REQUEST = `[auth] Logout request` as const;
export const LOGOUT_SUCCESS = `[auth] Logout success` as const;
export const LOGOUT_FAILED = `[auth] Logout failed` as const;

export const RESET_PASSWORD_REQUEST = `[auth] Reset password request` as const;
export const RESET_PASSWORD_SUCCESS = `[auth] Reset password success` as const;
export const RESET_PASSWORD_FAILED = `[auth] Reset password failed` as const;

export const CONFIRM_RESET_PASSWORD_REQUEST = `[auth] Confirm reset password request` as const;
export const CONFIRM_RESET_PASSWORD_SUCCESS = `[auth] Confirm reset password success` as const;
export const CONFIRM_RESET_PASSWORD_FAILED = `[auth] Confirm reset password failed` as const;

export const CONFIRM_REGISTRATION_REQUEST = `[auth] Confirm registration request` as const;
export const CONFIRM_REGISTRATION_SUCCESS = `[auth] Confirm registration success` as const;
export const CONFIRM_REGISTRATION_FAILED = `[auth] Confirm registration failed` as const;

export const UPLOAD_VERIFICATION_DOCUMENTS_REQUEST = `[auth] Upload verification documents request` as const;
export const UPLOAD_VERIFICATION_DOCUMENTS_SUCCESS = `[auth] Upload verification documents success` as const;
export const UPLOAD_VERIFICATION_DOCUMENTS_FAILED = `[auth] Upload verification documents failed` as const;

export const SHOW_UPLOAD_VERIFICATION_DOCUMENTS_MODAL = `[auth] Show upload verification documents modal` as const;
export const HIDE_UPLOAD_VERIFICATION_DOCUMENTS_MODAL = `[auth] Hide upload verification documents modal` as const;

export const CLEAR_ERROR = `[auth] Clear error` as const;
